import { ConfigWeight } from 'common/graphql/schemaDefinition'

export const weightMap: { [key in ConfigWeight]: string } = {
  [ConfigWeight.Default]: 'Normal',
  [ConfigWeight.Less]: 'Gering',
  [ConfigWeight.Few]: 'Sehr gering',
  [ConfigWeight.More]: 'Hoch',
  [ConfigWeight.Much]: 'Sehr hoch',
}
